// @ts-nocheck

"use client";

import Script from "next/script";

const handleJqueryReady = () => {
    $(document).ready(function(){
        var autoplayInterval = 4500; // Продолжительность интервала автовоспроизведения в миллисекундах
        var autoplayIntervalID; // Идентификатор интервала автовоспроизведения
        var animationStartTime; // Время начала анимации индикатора выполнения
        var progressAnimationDuration; // Продолжительность анимации индикатора выполнения
        var remainingAnimationTime; // Оставшееся время анимации индикатора выполнения
        var isPaused = false; // Флаг для отслеживания, если автовоспроизведение приостановлено из-за наведения мыши

        function showProgress($block) {
            $block.find(".block-sl-progress").show();

            progressAnimationDuration = autoplayInterval;
            $block.find(".block-sl-progress").css("animation-duration", progressAnimationDuration + "ms");

            // Установить время начала анимации
            animationStartTime = performance.now();
        }

        function hideProgress($block) {
            $block.find(".block-sl-progress").hide();
        }

        $(".block-sl-1-img").show();
        $(".block-sl-2-img, .block-sl-3-img, .block-sl-4-img").hide();
        $(".block-sl-1").addClass("active");
        showProgress($(".block-sl-1"));

        $(".block-sl-progress").on("animationend", function(){
            var currentActive = $(".block-sl.active").index();
            var nextActive = (currentActive + 1) % $(".block-sl").length;

            $(".block-sl").removeClass("active");
            $(".block-sl").eq(nextActive).addClass("active");

            $(".block-sl-1-img, .block-sl-2-img, .block-sl-3-img, .block-sl-4-img").hide();
            $(".block-sl-" + (nextActive + 1) + "-img").show();

            var $nextBlock = $(".block-sl-" + (nextActive + 1));
            showProgress($nextBlock);

            // Скрыть индикатор выполнения предыдущего блока
            var $prevBlock = $(".block-sl-" + (currentActive + 1));
            hideProgress($prevBlock);

            // Для мобильных устройств
            if ($(window).width() <= 767) {
                $(".block-sl").hide();
                $(".block-sl-" + (nextActive + 1)).show();
            }
        });

        var progressAnimationTimer;

        $(".block-sl").mouseenter(function() {
            if (!$(this).hasClass("active")) {
                return;
            }

            isPaused = true;
            var $progressBar = $(this).find(".block-sl-progress");
            $progressBar.data("wasRunning", $progressBar.css("animation-play-state") === "running");
            $progressBar.css("animation-play-state", "paused");
        }).mouseleave(function() {
            if (!$(this).hasClass("active")) {
                // Если блок не активен, то просто выходим из обработчика события
                return;
            }

            isPaused = false;
            var $progressBar = $(this).find(".block-sl-progress");
            if ($progressBar.data("wasRunning")) {
                $progressBar.css("animation-play-state", "running"); // Возобновить анимацию индикатора выполнения
            }
        });
        // Для мобильных устройств
        if ($(window).width() <= 767) {
            $(".block-sl").on('touchstart', function(event) {
                event.preventDefault(); // предотвращаем стандартное поведение при касании
                if ($(this).hasClass("active")) {
                    isPaused = !isPaused;
                    var $progressBar = $(this).find(".block-sl-progress");
                    if (isPaused) {
                        $progressBar.data("wasRunning", $progressBar.css("animation-play-state") === "running");
                        $progressBar.css("animation-play-state", "paused");
                    } else {
                        if ($progressBar.data("wasRunning")) {
                            $progressBar.css("animation-play-state", "running"); // Возобновить анимацию индикатора выполнения
                        }
                    }
                }
            });
        }
    });


    $(document).ready(function(){
        var autoplayInterval = 4500; // Продолжительность интервала автовоспроизведения в миллисекундах
        var autoplayIntervalID; // Идентификатор интервала автовоспроизведения
        var animationStartTime; // Время начала анимации индикатора выполнения
        var progressAnimationDuration; // Продолжительность анимации индикатора выполнения
        var remainingAnimationTime; // Оставшееся время анимации индикатора выполнения
        var isPaused = false; // Флаг для отслеживания, если автовоспроизведение приостановлено из-за наведения мыши

        function showProgress($block) {
            $block.find(".block-sl2-progress").show(); // Показать индикатор выполнения для активного блока

            // Установите продолжительность анимации индикатора выполнения, равную продолжительности интервала автозапуска
            progressAnimationDuration = autoplayInterval;
            $block.find(".block-sl2-progress").css("animation-duration", progressAnimationDuration + "ms");

            // Установить время начала анимации
            animationStartTime = performance.now();
        }

        function hideProgress($block) {
            $block.find(".block-sl2-progress").hide(); // Скрыть индикатор выполнения для неактивного блока
        }
        $(".block-sl-5-img").show();
        $(".block-sl-6-img, .block-sl-7-img").hide();
        $(".block-sl-5").addClass("active");

        showProgress($(".block-sl-5")); // Показывать индикатор выполнения для первого блока при загрузке страницы

        $(".block-sl2-progress").on("animationend", function(){
            var currentActive = $(".block-sl2.active").index();
            var nextActive = (currentActive + 1) % $(".block-sl2").length;

            $(".block-sl2").removeClass("active");
            $(".block-sl2").eq(nextActive).addClass("active");

            $(".block-sl-5-img, .block-sl-6-img, .block-sl-7-img").hide();
            $(".block-sl-" + (nextActive + 5) + "-img").show();

            var $nextBlock = $(".block-sl-" + (nextActive + 5));
            showProgress($nextBlock);

            // Скрыть индикатор выполнения предыдущего блока
            var $prevBlock = $(".block-sl-" + (currentActive + 5));
            hideProgress($prevBlock);

            // Для мобильных устройств
            if ($(window).width() <= 767) {
                $(".block-sl2").hide();
                $(".block-sl-" + (nextActive + 5)).show();
            }
        })

        // autoplayIntervalID = setInterval(autoPlay, autoplayInterval);
        var progressAnimationTimer;
        $(".block-sl2").mouseenter(function() {
            if (!$(this).hasClass("active")) {
                // Если блок не активен, то просто выходим из обработчика события
                return;
            }
            isPaused = true;
            // clearInterval(autoplayIntervalID); // Остановить автовоспроизведение при наведении курсора на активный блок
            var $progressBar = $(this).find(".block-sl2-progress");
            $progressBar.data("wasRunning", $progressBar.css("animation-play-state") === "running");
            $progressBar.css("animation-play-state", "paused"); // Приостановить анимацию индикатора выполнения
        }).mouseleave(function() {
            if (!$(this).hasClass("active")) {
                // Если блок не активен, то просто выходим из обработчика события
                return;
            }

            isPaused = false;
            var $progressBar = $(this).find(".block-sl2-progress");
            if ($progressBar.data("wasRunning")) {
                $progressBar.css("animation-play-state", "running"); // Возобновить анимацию индикатора выполнения
                // autoplayIntervalID = setInterval(autoPlay, autoplayInterval); // Возобновить автовоспроизведение
            }
        });
    });
}

export const PlatformScripts = () => {
    return <>
        <Script onReady={handleJqueryReady} src="https://code.jquery.com/jquery-3.6.4.min.js"/>
    </>
}